import React from "react";
import { DateTimeUtil } from "../../../utils";
import { ScheduleV2 } from "../../../types";
import { NgwAvatar } from "../../common";

interface ScheduleProps {
    schedule: ScheduleV2;
}

const ScheduleHeader: React.FC<ScheduleProps> = ({ schedule }) => {
    return (
        <div className="flex items-center bg-blue-500 text-white p-4">
            {/* Avatar */}
            <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center">
                <NgwAvatar
                    name={schedule?.emp_details?.emp_name}
                    src={schedule?.emp_details?.image_url}
                />
            </div>

            {/* Date Info */}
            <div className="ml-4 text-center">
                <div className="text-sm font-semibold uppercase tracking-wide text-gray-50">
                    {DateTimeUtil.getAbbreviatedDayName(schedule.shift_date || "")}
                </div>
                <div className="text-sm font-medium text-gray-50">
                    {DateTimeUtil.formatDate(schedule.start_time, "d MMM")}
                </div>
            </div>

            {/* Divider */}
            <div className="mx-4 h-10 border-l-2 border-yellow-500"></div>

            {/* Shift Details */}
            <div>
                <div className="text-lg font-bold leading-tight text-gray-50">
                    {DateTimeUtil.formatElegantTimeRange(schedule?.start_time, schedule?.end_time)}
                </div>
                {/* Uncomment if needed:
                <div className="text-sm">{schedule.emp_details?.emp_name || "Test master Vishwesh"}</div>
                <div className="text-sm text-gray-300">{schedule.shift?.shift_name}</div> */}
            </div>
        </div>
    );
};

export default ScheduleHeader;
